import Dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import SkeletonWidget from 'components/SkeletonWidget';

export const LeadFormComponent = Dynamic(
  () => import('components/LeadFormComponent'),
  { ssr: false, loading: () => <SkeletonWidget /> }
);

export default function WidgetPage() {
  const router = useRouter();

  return (
    <Box
      bgcolor="background.paper"
      component="section"
      py={2}
      textAlign="center"
    >
      <Container maxWidth="md">
        <Typography component="h1" fontWeight={600} variant="h4" mb={2}>
          {router?.query?.title || 'Faça seu orçamento de intercâmbio'}
        </Typography>
      </Container>

      <Container maxWidth="sm">
        <LeadFormComponent
          buttonText={router?.query?.cta || 'Comparar orçamentos'}
          id="external-widget"
        />
      </Container>
    </Box>
  );
}
